import { escapeHtml } from './escapeHtml'

// Leaflet renders popup/tooltip strings as HTML. `popupRow` is a pure markup helper — callers
// pass label/value already escaped (via escapeHtml) — so map layers and stratum popups share a
// single row shape instead of re-implementing the same template in three places.
export const popupRow = (label: string, value: string): string =>
  `<div style="display: flex; align-items: center; height: 15px">
    <p style="font-size: 11px; font-weight: bold">${label}:</p>
    <p style="font-size: 11px;">&nbsp;${value} </p>
  </div>`

export const propertiesPopupContent = (
  properties: Record<string, unknown> | null | undefined,
): string =>
  Object.entries(properties ?? {})
    .map(([key, value]) => popupRow(escapeHtml(key), escapeHtml(value)))
    .join('')
